











































































import Vue from 'vue'
import {secondsToHms} from "@/ts/utils";
import {EncounterResult, TestResult} from "@/ts/types";

export default Vue.extend({
    name: 'Game',
    components: {},
    data: () => ({
        loading: {
            fact: false,
            answer: false,
        },
        game: {
            startTime: 0,
            duration: 0,
            timeLeft: 1,
            fact: null as null | { fact_id: number, answer: string, question: string },
            userAnswer: '',
            factShownTimestamp: 0,
            correctAnswer: false,
            showFeedback: false,
            answerHistory: [] as EncounterResult[],
            encounteredFlags: new Set() as Set<string>,
        },
        timerInterval: -1,
    }),
    beforeDestroy() {
        clearInterval(this.timerInterval);
        document.removeEventListener('keypress', this.handleKey);
    },
    async mounted() {
        if (!this.connected)
            return await this.$router.push('/experiment');
        await this.newGame();
        document.addEventListener('keypress', this.handleKey, false);
    },
    methods: {
        handleKey(e: KeyboardEvent) {
            if (this.game.showFeedback && e.key === 'Enter') {
                this.nextFact();
            }
        },
        async newGame() {
            await this.$store.dispatch('resetModel', {
                subsetId: this.subsetId,
                enablePropagation: this.subsetId === this.$store.state.propagationSubsetId,
            });
            this.game.duration = this.sessionDuration * 60;
            this.game.timeLeft = this.game.duration;
            this.game.startTime = performance.now();
            await this.nextFact();
            this.timerInterval = setInterval(() => {
                let elapsed = (performance.now() - this.game.startTime) / 1000;
                this.game.timeLeft = this.game.duration - elapsed;
                if (this.game.timeLeft <= 0) {
                    this.game.timeLeft = 0;
                    this.stopGame();
                }
            }, 1000);
        },
        async stopGame() {
            clearInterval(this.timerInterval);
            let elapsed = (performance.now() - this.game.startTime) / 1000;
            let learnResult: TestResult = {
                duration: Math.min(this.game.duration, elapsed),
                history: this.game.answerHistory,
                encounteredFlags: this.game.encounteredFlags,
            };
            console.log('committing game result', learnResult);
            let modelStats = await this.$store.dispatch('getStats');
            console.log({modelStats});
            this.$store.commit('setModelStat', {subsetId: this.subsetId, modelStats})
            this.$store.commit('setLearnResult', {subsetId: this.subsetId, learnResult});
            await this.$router.push(`/experiment/test-intro/${this.subsetId}`)
        },
        async nextFact() {
            this.game.userAnswer = '';
            this.game.showFeedback = false;
            this.loading.fact = true;
            this.game.fact = await this.$store.dispatch('nextFact');
            this.game.encounteredFlags.add(this.game.fact?.question ?? 'Unknown');
            console.log({fact: this.game.fact});
            this.loading.fact = false;
            this.game.factShownTimestamp = performance.now();
            let userInput = this.$refs.userInput as any;
            userInput.focus();
        },
        async answerFact() {
            this.loading.answer = true;
            let responseTime = performance.now() - this.game.factShownTimestamp;
            let correct = await this.$store.dispatch('answerFact', {
                countryCode: this.game.fact?.question,
                answer: this.game.userAnswer,
                responseTime,
            }) as boolean;
            // calculate correct percentage including this last fact
            let correctHistory = [...this.game.answerHistory.map(a => a.correct), correct];
            let correctCount = correctHistory.reduce((a, b) => a + (b ? 1 : 0), 0) as number;
            let correctPercentage = correctCount / correctHistory.length;
            let rollSize = 5;
            let slicedHistory = correctHistory.slice(-rollSize);
            let rollCorrectCount = slicedHistory.reduce((a, b) => a + (b ? 1 : 0), 0) as number;
            let rollingAccuracy = rollCorrectCount / slicedHistory.length;
            // add to history
            this.game.answerHistory.push({
                rollingAccuracy,
                accuracy: correctPercentage,
                countryCode: this.game.fact?.question ?? '',
                correct,
                responseTime,
                userAnswer: this.game.userAnswer,
            });
            console.log("answered fact", {
                countryCode: this.game.fact?.question,
                answer: this.game.userAnswer,
                responseTime,
                correct,
            })
            this.game.correctAnswer = correct;
            this.game.showFeedback = true;
            this.loading.answer = false;

        },
        toHms(s: number) {
            return secondsToHms(s);
        },
    },
    computed: {
        subsetId(): number {
            return +this.$route.params.subsetId;
        },
        countries(): { [key: string]: string }[] {
            return this.$store.state.countries;
        },
        sessionDuration() {
            return this.$store.state.sessionDuration;
        },
        connected() {
            return this.$store.state.connected;
        },
        correctPercentage() {
            if (this.game.answerHistory.length === 0) return 1;
            let correctCount = this.game.answerHistory.reduce((a, b) => a + (b.correct ? 1 : 0), 0);
            return correctCount / this.game.answerHistory.length;
        },
    },
})
